import { action } from 'satcheljs';
export var getDomainState = action('getDomainState');
//# sourceMappingURL=getDomainState.js.map